export const STARTED_QUERY = { realStart: { $ne: null } };
export const NOT_FINISHED = { realFinish: { $eq: null } };
export const NOT_DELETED = { isDeleted: { $eq: false } };

export const MAY_START_SOON_QUERY = {
    $and: [
        { scheduledStart: { $gte: new Date(new Date().getTime() - 1 * 60 * 60 * 1000) } }, // Documents that have scheduledStart in the last hour
        { scheduledStart: { $lte: new Date(new Date().getTime() + 1 * 60 * 60 * 1000) } }, // Documents that have scheduledStart in the next hour
    ],
};

export const getMayStartSoonQuery = (threshold = 1) => {
    return {
        $and: [
            { scheduledStart: { $gte: new Date(new Date().getTime() - threshold * 60 * 60 * 1000) } },
            { scheduledStart: { $lte: new Date(new Date().getTime() + threshold * 60 * 60 * 1000) } },
        ],
    };
};

export const getTentativeCanStartQuery = () => {
    const nowDateObject = new Date();
    const nowIsoString = nowDateObject.toISOString();
    return {
        $and: [{ tentativeStartTime: { $lte: nowIsoString } }, { maxTentativeStartTime: { $gte: nowIsoString } }],
    };
};

export const ACTIVE_TRIPS_QUERY = {
    ...STARTED_QUERY,
    ...NOT_FINISHED,
    ...NOT_DELETED,
};

export const PENDING_AND_ACTIVE_TRIPS_QUERY = {
    ...NOT_FINISHED,
    ...NOT_DELETED,
};

export const getActiveTripsByDefinitionQuery = (tripDefinitionId: string) => {
    if (!tripDefinitionId) throw new Error('tripDefinitionId is required to build the ACTIVE_TRIPS_QUERY');
    return { ...ACTIVE_TRIPS_QUERY, tripDefinition: tripDefinitionId };
};

export const getPendingAndActiveTripsByDefinitionQuery = (tripDefinitionId: string) => {
    if (!tripDefinitionId) throw new Error('tripDefinitionId is required to build the PENDING_AND_ACTIVE_TRIPS_QUERY');
    return { ...PENDING_AND_ACTIVE_TRIPS_QUERY, tripDefinition: tripDefinitionId };
};
